import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const SupportList = Loadable(
  lazy(() =>
    import("./supportList").then(({ SupportList }) => ({
      default: SupportList,
    }))
  )
);

const ManageSupport = Loadable(
  lazy(() =>
    import("./manageSupport").then(({ ManageSupport }) => ({
      default: ManageSupport,
    }))
  )
);

export const supportRoutes = [
  {
    path: "/enr-support",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <SupportList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/support/manage",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <ManageSupport />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/support/manage/:supportTicketId",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <ManageSupport />
      </AuthorizedRoute>
    ),
  },
];
